require('./reviews.scss')

module.exports = {
  template: require('./reviews.pug')()
  controller: require('./reviews.ctrl')
  bindings:
    salon: '<'
}
